var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "booking-view" }, [
    _c(
      "div",
      { staticClass: "booking-view__header" },
      [
        _c("order-progress", { attrs: { step: 3 } }),
        _vm._v(" "),
        _vm.hotelData
          ? _c("hotel-block-header", {
              class: {
                "hotel-block-header--agency": true,
                "hotel-block--loading": _vm.hotelLoading
              },
              attrs: { agency: true, hotel: _vm.hotel },
              on: { goback: _vm.goBack }
            })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "booking-view__body" },
      [
        _c("booking-messages", {
          attrs: {
            loadingOffer: _vm.loadingOffer,
            loadingError: _vm.loadingError,
            isNKOffer: _vm.isNKOffer,
            bookingError: _vm.makeBookingerror,
            bookingState: _vm.makeBookingState,
            adminWarning: _vm.showAdminWarning,
            changeList: _vm.changeList,
            inEditMode: _vm.inEditMode
          },
          on: { goback: _vm.goBack }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "booking-view__body__flex" },
          [
            _vm.showBookingFields
              ? _c("booking-travel", { attrs: { "offer-data": _vm.offerData } })
              : _vm._e(),
            _vm._v(" "),
            _c("booking-form", {
              ref: "bookingform",
              attrs: {
                ready: _vm.showBookingFields,
                changeList: _vm.changeList
              },
              on: {
                editmode: function(val) {
                  return (_vm.inEditMode = val)
                },
                dobooking: _vm.doBooking,
                userConsentedPrice: _vm.setUserConsentPrice
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7260d14c", { render: render, staticRenderFns: staticRenderFns })
  }
}